import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
};

const DisableContextMenu = ({ children }: Props) => (
	<div
		style={{ display: "contents" }}
		onContextMenu={(event) => event.preventDefault()}
		onDragStart={(event) => event.preventDefault()}
	>
		{children}
	</div>
);

export default DisableContextMenu;
